import { FileUpload } from 'primereact/fileupload';
import { useEffect, useState } from "react";
import { useGetAuftragFilesMutation } from '../api/AuftragAPI';
import { IFilesFromAuftrag } from "../pages/auftrag/AuftragDetails";
import { downloadFile, upload } from "../services/All";
import { formatToStringISODate } from '../util/DateUtils';
import styles from './component.module.scss';

type UploadFilesParameter = {
  uid: string
}

export default function UploadToServer({ uid }: UploadFilesParameter) {

  const [dateienVonAuftrag, setDateienVonAuftrag] = useState<IFilesFromAuftrag>();
  const [getAuftragDateien] = useGetAuftragFilesMutation();

  const handleDownload = async (uid: string) => {
    try {

      downloadFile(uid)
        .then((resp) => {
          const contentDisposition = resp?.headers["content-disposition"] || resp?.headers["Content-Disposition"];
          const contentType = resp?.headers["content-type"] || resp?.headers["Content-Type"];

          let filename = "filename";
          let extractedFileName = filename;
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+)"/);
            if (match && match[1]) {
              extractedFileName = match[1];
            }
          }

          const blob = new Blob([resp.data], { type: contentType });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = extractedFileName;
          link.click();
          link.remove();
        });
    } catch (error) {
      console.error("Download-Fehler:", error);
    }
  };

  const uploadFile = (file: File) => {
    upload(uid, file)
      .then(() => {
        getAuftragDateien(uid).unwrap().then((data) => setDateienVonAuftrag(data));
      })
      .catch(error => console.log(error));
  }

  useEffect(() => {
    if (!uid) return;
    getAuftragDateien(uid).unwrap().then((data) => setDateienVonAuftrag(data));
  }, [uid]);

  return (
    <div>

      {dateienVonAuftrag?.files.map((e, index) =>
          <div key={index} className={styles["auftragCard"]} >

            <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr', columnGap: "10px" }}>

              <div>
                <img src={`data:image/png;base64, ${e.data}`} width={100} />
              </div>
              <div>

                <p style={{ fontSize: "10pt" }}>{e.filename}</p>
                <p>
                  Erstellt am: {formatToStringISODate(e.createDateTime)}
                </p>
                <p>
                  <button className="btn btn-primary" onClick={() => { handleDownload(e.uid) }}><i className="bi bi-cloud-arrow-down-fill" />&nbsp;Download</button>
                </p>
              </div>

            </div>
          </div>
      )}

      Upload Neue Dateien:
      <div className="card">
        <FileUpload name="demoFileUpload"
          url={process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + 'imageUpload'}
          multiple
          accept="image/*"
          maxFileSize={5000000}
          emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>}
          customUpload
          auto={true}
          uploadHandler={async (event) => {
            const filelist = event.files;
            if (filelist !== undefined && filelist !== null) {
              uploadFile(filelist[0]);
            }
            event.options.clear();
          }}
        />
      </div>
    </div>

  )
}